import { createContext, useContext, useState, useEffect } from 'react';

const HomeContext = createContext();

export const HomeProvider = ({ children }) => {
    const [homeData, setHomeData] = useState({
        hero: null,
        featuredProduct: null,
        doubleSlider: null,
        bicycles: [],
        scooters: []
    });
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchHomeData = async () => {
        try {
            setIsLoading(true);
            const response = await fetch('https://backend.bicicletasjavacolombia.com/api/home');
            // const response = await fetch('http://127.0.0.1:8000/api/home');
            const data = await response.json();

            if (data.maintenanceMode) {
                setError(data.message);
                return;
            }

            setHomeData({
                hero: data.hero,
                featuredProduct: data.featuredProduct,
                doubleSlider: {
                    product1: data.doubleSlider.product1,
                    product2: data.doubleSlider.product2
                },
                bicycles: data.bicycles,
                scooters: data.scooters
            });
        } catch (err) {
            setError('Error loading home data');
            console.error('Error fetching home data:', err);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchHomeData();
    }, []);

    const refreshHomeData = () => {
        fetchHomeData();
    };

    return (
        <HomeContext.Provider 
            value={{ 
                ...homeData, 
                isLoading, 
                error,
                refreshHomeData 
            }}
        >
            {children}
        </HomeContext.Provider>
    );
};

export const useHome = () => {
    const context = useContext(HomeContext);
    if (context === undefined) {
        throw new Error('useHome must be used within a HomeProvider');
    }
    return context;
};
